import './PamiatkiTopSlider.less';
import {getWindowWidth} from '../../js/core/Helpers/Helpers';


const pamiatkiTopSlider = () => {
    let selector = '.pamiatkiTopSlider';
    let vanillaSlider = document.querySelector(selector);
    if (vanillaSlider) {
        let slider = $(selector);
        
        const initClickHandler = () => {
            const clickables = [...document.getElementsByClassName('js-clickable-slide')];
            const btns = [...document.getElementsByClassName('js-slide-btn')];
            let proposals = [...document.getElementsByClassName('proposalProducts')];
            
            btns.forEach(btn => btn.addEventListener('click', e => location = e.currentTarget.dataset.url ));

            const setActive = e => {
                e.preventDefault();
                clickables.forEach(slide => {
                    slide == e.currentTarget ?
                        e.currentTarget.parentElement.classList.add('active') :
                        slide.parentElement.classList.remove('active');
                });
                proposals.forEach(proposalList => {
                    proposalList.getAttribute('id') === `js-proposals-${e.currentTarget.parentElement.dataset.id}` ?
                        proposalList.classList.remove('closed') :
                        proposalList.classList.add('closed');
                })

            };
            
            clickables.forEach(slide => {
                slide.addEventListener('click', e => {
                    getWindowWidth() > 1199 ?
                        setActive(e):
                        null;
                });
            });
        };
        
        slider.owlCarousel({
            loop: false,
            merge: true,
            rewind: true,
            margin: 0,
            animateOut: 'fadeOut',
            autoplayTimeout: 10000,
            mouseDrag: false,
            autoplayHoverPause: false,
            autoplay: true,
            responsiveClass: true,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            dots: true,
            items: 1,
            nav: false,
            responsive: {
                320: {
                    items: 1,
                    touchDrag : true,
                    nav: true
                },
                500: {
                    items: 2,
                    touchDrag : true,
                    nav: true
                },
                768: {
                    items: 3,
                    touchDrag : true,
                    nav: true
                },
                992: {
                    items: 5,
                    touchDrag : false,
                    nav: false
                }
            }
        });
        
        slider.on('changed.owl.carousel', function (event) {
        
        });
    
    
        initClickHandler();
    }
};

export default pamiatkiTopSlider;


// WEBPACK FOOTER //
// ./components/pamiatkiTopSlider/PamiatkiTopSlider.js